import comp from "./StudentAssignmentMessaging";
export default comp;
